/* eslint-disable eqeqeq */
import { Box } from "../../../../../../components";
import { formFields1, formFields2 } from "../../constant/field-names";
import { Form, Row } from "antd";
import { useState } from "react";
import { PATH } from "../../constant/path";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import {
  RenderApprover,
  RenderCreateFormButton,
  RenderHelper,
  RenderUnit,
} from "../../../../human-organization/summary-employee-request/utils/render-helper";
import { MeetingRequestService } from "../../../../../../services/company-office/MeetingRequest.service";
import { requestStatus } from "../../../../../../constants";
import { useSoftwares } from "../../../../../../hook";
import { SystemCode } from "../../../../../../constants";
import { MAIL_TEMPLATE } from "../../constant/mail-template";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";
import { useSelector } from "../../../../../../store/store";
import { getEnv } from "../../../../../../AppConfigs";

const siteUrl = getEnv("REACT_APP_MEETING_REQUEST");

export function CreateForm() {
  const [form] = Form.useForm();
  const [department, setDepartment] = useState("");
  const { getITLeadITHeadAssignee } = useSoftwares();

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      setDepartment(changedValues.eDepartment);
    }
  };

  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  
  const history = useHistory();

  const onFinish = async (values: any) => {
    try {
      let initFields: any = {
        Title: "ĐỀ NGHỊ SỬ DỤNG PHÒNG HỌP",

        eRequestStatus: requestStatus.submitted,
        eApprovedStatus: requestStatus.submitted,

        eApprovedByITLeadStatus: requestStatus.submitted,
        eApprovedByITLead: getITLeadITHeadAssignee(SystemCode.MR)
          .eAssignee.split("|")[0]
          .toLowerCase(),

        eApprovedBy:
          values.pickedUser && values.pickedUser != ""
            ? values.pickedUser.split("|")[0].toLowerCase()
            : values.eApprovedBy.split("|")[0].toLowerCase(),
        eApprovedName:
          values.pickedUser && values.pickedUser != ""
            ? values.pickedUser.split("|")[1]
            : values.eApprovedBy.split("|")[1],
      };

      formFields1.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      formFields2.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      initFields = {
        ...initFields,
        eUnit: values.eUnit,
      };

     const detail =  await MeetingRequestService.addMeetingRequest({
        fields: {
          ...initFields,
        },
      });

      sendEmail(
        detail,
        MAIL_TEMPLATE.APPROVE,
        values.pickedUser && values.pickedUser != ""
          ? values.pickedUser
          : values.eApprovedBy,
        mailtemplates,
        "",
        siteUrl
      );

      CreateNotification({
        title: "Thành công",
        body: "Tạo yêu cầu thành công",
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
    } catch (error) {
      history.push(PATH.HOME);
      CreateNotification({
        title: "Thất bại",
        body: `Tạo yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
    }
  };

  return (
    <>
      <Form
        size="large"
        onFinish={onFinish}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Box title="Thông tin">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields1} />
            <RenderUnit department={department} form={form} span={8} mode="create"/>
          </Row>
        </Box>

        <Box title="Thông tin chi tiết">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields2} />
            <RenderApprover department={department} form={form} />
            <RenderCreateFormButton homePath={PATH.HOME} />
          </Row>
        </Box>
      </Form>
    </>
  );
}
